// CAUTION: this file is imported by apex
import React from 'react';
import PropTypes from 'prop-types';
import {
  Switch,
  Route,
  useRouteMatch
} from 'react-router-dom';

import LeadShow from './show';

// Represents the entire project leads section, for routing between the leads list and an individual lead.
export default function Leads({ children, documentCenter, tasksEnabled }) {
  const { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          {children}
        </Route>
        <Route path={`${path}/:id`}>
          <LeadShow documentCenter={documentCenter} hasTasksEnabled={tasksEnabled} />
        </Route>
      </Switch>
    </div>
  );
}

Leads.propTypes = {
  children: PropTypes.node.isRequired,
  documentCenter: PropTypes.bool.isRequired,
  tasksEnabled: PropTypes.bool.isRequired
};
